import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { split } from 'lodash'

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    errors: {
      min: 'Minimum number is {{min}}',
      max: 'Max {{max}}',
      number: 'This field must be a number',
      generic: 'An error has occurred, please contact us or try again later',
    },
    translations: {
      propertyDetail: {
        privateRoom: 'Private room',
        sharedRoom: 'Shared room',
        entireProperty: 'Entire property',
        villa: 'Villa',
        loft: 'Loft',
        studio: 'Studio',
        mate: {
          singular: 'Mate',
          plural: 'Mates',
        },
        room: {
          singular: 'Room',
          plural: 'Rooms',
        },
        bath: {
          singular: 'Bathroom',
          plural: 'Bathrooms',
        },
        people: {
          plural: 'People',
          singular: 'Mate',
        },
        genderM: 'Men',
        genderF: 'Women',
        genderA: 'Anyone',
        price: {
          justForFirstMonth: 'There is a one-time commission of 50% of monthly fee to pay in the first month',
          justForFirstMonth50: 'There is a one-time commission of 50% of monthly fee to pay in the first month',
          justForFirstMonth100: 'There is a one-time commission of 100% of monthly fee to pay in the first month',
          justForFirstMonth150: 'There is a one-time commission of 150% of monthly fee to pay in the first month',
          commissionTooltip:
            'For rentals of less than one year, a one-time fee is required equal to 50% of the monthly total which will be credited upon payment of the first rent.',
          totalRentAmount: 'Total rent monthly amount',
          priceSetByLandlordExplanation: 'Price set by the landlord, but you can suggest a different one',
          consumption: 'Consumptions',
          commissionsOnlyFirst: 'Commissions (only first month)',
          commissions: 'Commissions',
          commissionsHelp: 'For stays shorter than 6 months, we are obliged to charge you a commission fee',
          total: 'Total',
          explainStandard: 'The fee is {{amount}}{{currency}} for month. See the detail!',
          detail: "Here's how the detail is composed",
          standard: 'Rent amount',
          expense: 'Bills',
          tari: 'Tari (tax due on waste)',
        },
        paymentSummary: {
          title: 'Riepilogo del pagamento',
          howMuchWillYouPayNow: 'How much you have to pay now',
          firstMonthRentDeposit: 'On account of the first month’s rent',
          afterLandlordAccept: 'Once the property owner accept your proposal',
          firstMonthRentBalanceWithPrePayment: 'First month of rent {{amount}}€  minus the €{{pre_payment}} you are paying now',
          firstMonthRentBalanceWithoutPrePayment: 'First month of rent {{amount}}€ ',
          approvedCreditPaymentBeforeEnteringHome: 'Payment on credit approved – before moving into the house.',
          zappyrentCommissionAndDepsoit: 'ZappyRent commission {{commission}}€ + Security deposit {{deposit}}€'
        }
      },
      number: {
        numberNotVerified: 'Verification code wrong',
        phone: 'Phone number',
        code: 'Verification code',
        validateNumber: 'Validate number',
        sentMessage: 'Message sent',
        phoneInvalid: 'Phone number not valid',
      },
      salesForce: {
        error: 'An error has occurred, please contact us via chat',
      },
      visit: {
        booked:
          'Thanks for the request, one of our consultants will call you to confirm the appointment for the {{date}} at {{time}}',
        action: 'Back to search',
        first: {
          title: 'Not sure yet? Schedule an appointment with our agent and visit the apartment',
          label: 'When do you want to visit the apartment?',
          form: {
            placeholders: {
              date: 'Visit date',
              time: 'Time',
            },
          },
        },
        second: {
          title: 'We are looking forward to show you the apartment',
          subtitle: 'We are looking forward to show you the apartment',
          form: {
            labels: {
              name: 'Name',
              surname: 'Surname',
              email: 'Email',
            },
          },
        },
      },
      booking: {
        checkFaq: 'Check here all the information you need to know to rent with Zappyrent!',
        checkFaqLink: 'https://zappyrent.zendesk.com/hc/en-us/articles/4407492167953-FAQ-and-Support',
        questions: {
          title: 'Have questions? We have answers!',
          0: {
            question: 'When am I charged for a reservation?',
            response:
              'Your payment information is collected when you submit a reservation request. Once the landlord accepts your request, your payment method will be charged for the first month of rent. Whether the reservation is two days or two months away, we hold the payment until 24 hours after check-in before giving it to the landlord. This hold gives both parties time to make sure that everything is as expected.',
          },
          1: {
            question: 'Who holds the security deposit?',
            response:
              'Landlords decide how many months of rent they would like to hold as security deposit. Zappyrent will hold such deposit to guarantee that you will get it back at the end of the tenancy. One day before the check-in Zappyrent will ask your bank to hold an amount equal to the security deposit on the card you used to pay. 24h hours after you move in we will transfer the security deposit on your Zappyrent account, where it will be frozen until the end of the tenancy. This method will allow you to transfer the deposit only after you have seen the apartment, and the landlord to be sure you have enough funds to cover the deposit.',
          },
          2: {
            question: 'How do I pay for future months?',
            response:
              'After the check in, the monthly payment will be handled with bank transfer. In order to do these payments, you will receive all the information needed by SMS and on your email. ',
          },
        },
        title: 'Send your request in 60 seconds!',
        checkIn: {
          dateCheckIn: {
            title: 'For what period would you like to rent?',
            placeholder: 'Check-In date',
            errors: {
              containsBooking: 'Check in date not valid, there is a booking in this period',
            },
          },
          dateCheckOut: {
            title: 'Insert check-out date',
            placeholder: 'Check-Out date',
          },
          people: {
            title: 'How many people?',
            placeholder: 'How many people are moving in?',
          },
          duration: {
            title: 'Indicate the approximate duration of your rental',
            placeholder: 'Rent duration',
            over12Months: 'Over 12 months',
            under12Months: '12 months or less',
          },
          warningMessage:
            'To prepare all documents for your rental it might take up to 20 days. If you choose a date sooner than 20 days, please consider that we might have to postpone your check-in date',
        },
        userInfo: {
          title: 'Tell us more about you!',
          age: {
            title: 'How old are you?',
            placeholder: 'Insert age',
            error: 'Age must be between 18 and 99 years',
          },
          gender: {
            title: "What's your gender?",
            placeholder: 'Select a gender',
            male: 'Male',
            female: 'Female',
            notSpecified: 'Not specified',
          },
          work: {
            title: 'Which is your profession?',
            placeholder: 'Select your profession',
            italianStudent: 'Italian Student',
            foreignStudent: 'Foreign Student',
            selfEmployed: 'Self Employed',
            employee: 'Employee',
          },
          nationality: {
            title: 'Where are you from?',
            placeholder: 'Select your country',
          },
          message: {
            title: 'Tell the landlord about yourself and add any requests',
            placeholder:
              'Do you need to negotiate any repairs, additions or withdrawals with the owner or the possibility of having a pet in the house?',
          },
        },
        paymentInfo: {
          title: 'Send your request!',
          easypay: {
            heardAboutEasypay: 'Do you want to pay in installments with EasyPay?',
            serviceFeeAndSecurityDeposit: "Now you can split your service fee and security deposit into 24 monthly payments of just {{price}}{{currency}}!<br />And the best part? Once your contract ends, you’ll get your security deposit back.",
          },
          titleCounteroffer: 'If you accept counter offer you get the accommodation you want.',
          subtitleTitleCounteroffer:
            'Just add your payment method and click on Accept to secure the place. We will hold the first month of rent until you move in your new home.',
          adviceCost: {
            title: 'Apartment too expensive? Advice your price.',
            subtitle:
              "You can propose a preferred rental amount, but acceptance isn't guaranteed. If accepted, all amounts will adjust accordingly.",
            subtitleOwnerIsPropertyManager: 'You cannot offer a lower price for this property',
            min75percentage:
              'Landlords don’t accept very high discounts. Please make a higher offer or <1>go back to the listing page filtered for maximum price {{price}}€</1>',
          },
          typePayment: {
            title: 'Pay with',
            placeholder: 'Select a payment method',
            card: 'Pay with card',
            banktransfer: 'Pay with bank transfer',
            confidentText: '100% money back guaranteed in case of booking not accepted or if you have credit check rejected.',
          },
          card: {
            number: 'Card number',
            expire: 'Expires',
            cvc: 'CVC',
            notSupported: 'Ops, this card is not accepted. Try again with another card.',
          },
          toChangePaymentDetails: 'To change your payment details, please click <1>{{hereText}}</1>',
          here: 'here',
          cardHolderName: 'Card holder name',
          cardHolderEmail: 'Card holder email',
          cardHolderAddress: 'Card holder address',
          cardHolderCity: 'Card holder city',
          cardHolderZip: 'Card holder zip',
          cardHolderCountry: 'Card holder country',
          transfer: {
            alert:
              "Your offer will reach the landlord only when the payment is visible in the system. Attention: Bank transfer may take up to 5 days to be recorded, <strong>don't lose your new home!</strong>",
            uploadInputHeader: 'Upload the receipt of your transfer',
            receipt: 'Receipt',
            confirmDeleteReceipt: 'Are you sure, you want to delete the receipt?',
            checkingReceipt: 'Checking receipt...',
            refreshButton: 'Refresh the page',
            noResponseErrorUploadTitle: 'Error while uploading',
            noResponseErrorUploadAlert: `Oops! It seems we're experiencing an unexpected issue. Please refresh the page and attempt to upload the document again
            if it hasn't already been uploaded. If you're still encountering difficulties, don't hesitate to reach out to us for
            further assistance. Thank you for your patience!`,
          },
          termsAndCondition: {
            title:
              'I understand that in case the payment is not confirmed this request is going to be cancelled, and I agree with ZappyRent <1>terms and conditions</1>.',
            error: 'You need to confirm in order to continue with the request.',
          },
          collaborateWithUs: "Collaborate with us",
        },
      },
      changePaymentMethod: {
        title: 'Change payment method for booking!',
        subtitle:
          'You can update your card details for your booking, we will keep this information securely. \n We will not charge any amount.',
        form: {
          success: 'Payment method change successful',
          error: 'An error has occurred, please try again later',
        },
      },
      form: {
        next: 'Continue',
        complete: 'Confirm',
        back: 'Back',
        amount:
          "At this moment you're paying <1>0€<1>. We will charge you the first payment ({{price}}€)<2>*</2> when your offer is accepted by the landlord.",
        acceptCounteroffer: 'Accept',
        rejectCounteroffer: 'Reject',
        counterofferRejectedMessage: 'Counteroffer rejected correctly',
      },
      banners: {
        ratting: 'More than 93% tenants satisfied with our services',
        nextSteps: 'Next steps',
        downloadOfficialDocument: 'After confirming, <1>you can download an official document</1> with your booking details.',
        firstMonthRentWithPrePayment:
          'Upon landlord’s acceptance, you need to <1>pay the first month of rent</1> minus what you already paid (200€) in 24 hours.',
        firstMonthRentWithoutPrePayment:
          'Upon landlord’s acceptance, you need to <1>pay the first month of rent</1> in 24 hours.',
        creditCheckAnalysis: 'Then, we will run a <1>credit check analysis</1> on the documents you submitted.',
        zappyrentCommision: 'Once you are approved in credit check, you will <1>pay the Zappyrent commission</1> in 24 hours.',
        moneyBackGuaranteed: '<1>100% money back guaranteed</1> if your booking is not accepted or credit check not approved.',
      },
      fundingInstruction: {
        account: 'Account holder',
        nation: 'Nation',
      },
      easyPayPlan: {
        title: 'EasyPay Plan',
        moveIntoHomeWithoutPayingAnything: 'Do you want to move into a house without paying anything or just a small amount in advance?',
        advertise: {
          title: 'EasyPay',
          heading: 'Move into your new home <1>without paying anything</1>, or just a small amount!',
          disclaimer: 'Pay <1>commission and security deposit</1>  in 24 convenient monthly installments',
          footerPara: 'Book with EasyPay and enjoy all the other subscription benefits!!',
          footerNote: '*(up to {{easy_pay_loan_amount}}{{currency}}) '
        },
        benefit: {
          title: 'Book with EasyPay and enjoy all the advantage!',
          benefit_1: '<1>Greater financial flexibility:</1> You can pay the commission and security deposit in 24 installments.',
          benefit_2: '<1>Priority support:</1> Get a direct and fast channel to receive help whenever you need it most.',
          benefit_3: '<1>Early check-out inspection:</1> With our assistance, you’ll have the chance to resolve any issues caused during your stay, avoiding charges from your security deposit.',
          benefit_4: '<1>Rent payment flexibility:</1> Instead of paying on the 1st, you can pay your rent up to the 8th of the month without penalties.',
          benefit_5: '<1>Deposit refund:</1> At the end of the contract, you will receive your security deposit back, provided the contract terms are respected and depending on the apartment’s condition.',
          bookWithEasyPay: 'Book with EasyPay',
          discoverOtherAdvantages: 'Discover the other benefits',
        },
        bookWithEasyPayPlan: {
          title: 'I would like to book with EasyPay',
          subtitle: 'To pay <1>before moving to the house:</1>',
          installment: '<1>Monthly</1> payment for <1>24 months:</1>',
          disclaimer: '*The cost of EasyPay ({{premium_fee}}{{currency}}) is already included'
        },
        bookWithoutEasyPayPlan: {
          title: 'I would like to book without EasyPay',
          subtitle: 'To pay before moving to the house:',
          disclaimer: 'ZappyRent commission {{commission}}{{currency}} + Security deposit {{deposit}}{{currency}} = {{upfront_total}}{{currency}}'
        },
        tooltip: {
          title: 'Da pagare prima di entrare in casa:',
          tip_1: '1. Commission + Deposit = <1>{{currency}}{{comission_plus_deposit_amount}}</1>',
          tip_2: '2. Amount <1>covered by EasyPay</1> = <2>{{currency}}{{easy_pay_amount}}</2>',
          tip_3: '3. Total requested with EasyPay (costs EasyPay included {{premium_fee_amount}}{{currency}}) = <1>{{currency}}{{easypay_total_amount}}</1>',
          disclaimer: 'Amount to be paid before moving to the house (1 - 2)  = {{currency}}{{easypay_remaining_amount}}'
        }
      }
    },
  },
  it: {
    errors: {
      min: 'Il valore minimo del campo è {{min}}',
      number: 'Questo campo deve contenere un numero',
      generic: 'Si è verificato un errore, contattaci oppure riprova tra qualche istante',
    },
    translations: {
      propertyDetail: {
        privateRoom: 'Stanza privata',
        sharedRoom: 'Stanza condivisa',
        entireProperty: 'Intera proprietà',
        studio: 'Monolocale',
        mate: {
          singular: 'Coinquilino',
          plural: 'Coinquilini',
        },
        room: {
          singular: 'Stanza',
          plural: 'Stanze',
        },
        bath: {
          singular: 'Bagno',
          plural: 'Bagni',
        },
        people: {
          singular: 'Persona',
          plural: 'Persone',
        },
        genderM: 'Uomini',
        genderF: 'Donne',
        genderA: 'Chiunque',
        price: {
          justForFirstMonth: 'Solo per il primo mese chiediamo una commissione pari al 50% dell’affitto',
          justForFirstMonth50: 'Solo per il primo mese chiediamo una commissione pari al 50% dell’affitto',
          justForFirstMonth100: 'Solo per il primo mese chiediamo una commissione pari al 100% dell’affitto',
          justForFirstMonth150: 'Solo per il primo mese chiediamo una commissione pari al 150% dell’affitto',
          commissionTooltip:
            'Per affitti inferiori alla durata di un anno, viene richiesta una commissione solo per una volta pari al 50% del totale mensile che verrà accreditata al pagamento del primo affitto.',
          standard: "Canone d'affitto",
          priceSetByLandlordExplanation: 'Prezzo impostato dal proprietario, ma puoi proporne un prezzo diverso',
          expense: 'Spese',
          consumption: 'A consumo',
          commissionsOnlyFirst: 'Commissioni (solo il primo mese)',
          commissions: 'Commissioni',
          commissionsHelp: 'Per durate inferiori di 6 mesi, siamo costretti a chiedere una commissione',
          total: 'Totale mensile',
          explainStandard: 'Il canone è di {{amount}}{{currency}} / mese. Vedi il dettaglio!',
          detail: 'Ecco come è composto il dettaglio',
          tari: 'Tari',
          totalRentAmount: 'Importo totale del canone mensile',
        },
        paymentSummary: {
          title: 'Riepilogo del pagamento',
          howMuchWillYouPayNow: 'Quanto pagherai ora',
          firstMonthRentDeposit: 'Sull\'acconto del primo mese di affitto',
          afterLandlordAccept: 'Dopo l’accettazione del locatore',
          firstMonthRentBalanceWithPrePayment: 'Saldo del primo mese di affitto: {{amount}}€ meno \nquanto paghi ora {{pre_payment}}€',
          firstMonthRentBalanceWithoutPrePayment: 'Saldo del primo mese di affitto: {{amount}}',
          approvedCreditPaymentBeforeEnteringHome: 'Pagamento a credito approvato - prima di entrare in casa',
          zappyrentCommissionAndDepsoit: 'Commissione ZappyRent {{commission}}€ + Deposito Cauzionale {{deposit}}€'
        }
      },
      number: {
        numberNotVerified: 'Codice di verifica errato',
        placeholder: 'Inserisci numero di telefono',
        phone: 'Numero di telefono',
        code: 'Codice di verifica',
        validateNumber: 'Valida numero',
        sentMessage: 'Messaggio inviato',
        phoneInvalid: 'Numero di telefono non valido',
      },
      salesForce: {
        error: "C'è stato un errore, contattaci tramite chat",
      },
      visit: {
        booked:
          'Grazie per la richiesta, un nostro consulente ti chiamerà per confermare l’appuntamento per la data {{date}} alle ore {{time}}',
        action: 'Torna alla ricerca',
        first: {
          title: 'Non sei ancora convinto? Prenota un appuntamento con un nostro consulente e visita l’appartamento!',
          label: 'Quando vorresti fare la visita in persona?',
          form: {
            placeholders: {
              date: "Data dell'appuntamento",
              time: 'Fascia Oraria',
            },
          },
        },
        second: {
          title: 'Non vediamo l’ora di incontrarti per visitare insieme l’appartamento!',
          subtitle: 'Non vediamo l’ora di incontrarti per visitare insieme l’appartamento!',
          form: {
            labels: {
              name: 'Nome',
              surname: 'Cognome',
              email: 'Email',
            },
          },
        },
      },
      booking: {
        title: 'Invia la tua richiesta in 60 secondi!',
        checkFaq: 'Controlla qui tutte le informazioni da sapere per affittare con Zappyrent',
        checkFaqLink: 'https://zappyrent.zendesk.com/hc/it/articles/4407492167953-FAQ-Inquilino',
        questions: {
          title: 'Hai domande? Noi abbiamo le risposte!',
          0: {
            question: 'Quando mi viene addebitata la prenotazione?',
            response:
              'I dati del tuo pagamento vengono salvati quando invii una richiesta di prenotazione. Non appena il proprietario accetta, Zappyrent addebiterà la prima mensilità sul tuo metodo di pagamento. Non importa se la prenotazione è fra due giorni o due mesi: Zappyrent trattiene il tuo pagamento fino a 24 ore dopo il check-in prima di inviarlo al proprietario. Questo sistema permette a entrambe le parti di assicurarsi che tutto vada come previsto.',
          },
          1: {
            question: 'Chi custodice il deposito?',
            response:
              "Il proprietario sceglie il numero di mensilità richieste come deposito cauzionale ma è Zappyrent a custodire il tuo deposito per garantirti la restituzione a fine locazione. Il giorno prima del check-in, Zappyrent preautorizzerà l'addebito sulla carta di credito/debito inserita in fase di prenotazione per l'intero importo del deposito cauzionale richiesto dal proprietario. 24h dopo il tuo ingresso in casa, la preautorizzazione si trasformerà in addebito reale e l'importo sarà dedotto dalla tua carta di credito/debito. Questo permette all'inquilino di non vedersi addebitato il deposito prima di essere entrato in casa ma, allo stesso tempo, il proprietario è sicuro che l'inquilino sarò in grado di pagare il deposito cauzionale richiesto.",
          },
          2: {
            question: 'Come avviene il pagamento delle altre mensilità?',
            response:
              'Dopo il check-in, il pagamento mensile sarà gestito tramite bonifico bancario. Per effettuare questi pagamenti, riceverete tutte le informazioni necessarie via SMS e sulla vostra e-mail.',
          },
        },
        checkIn: {
          dateCheckIn: {
            title: 'Per quale periodo vorresti affittare?',
            placeholder: 'Data Check-In',
            errors: {
              containsBooking: 'Data di check-in non valida, esiste un booking in questo periodo',
            },
          },
          dateCheckOut: {
            title: 'Inserisci la data di check-out',
            placeholder: 'Data Check-Out',
          },
          people: {
            title: 'Per quante persone?',
            placeholder: 'Numero persone',
          },
          duration: {
            title: 'Indicaci la durata orientativa del tuo affitto',
            placeholder: "Durata dell'affitto",
            over12Months: 'Oltre i 12 mesi',
            under12Months: '12 mesi o meno',
          },
          warningMessage:
            'Per completare il processo di affitto potrebbero volerci fino a 20 giorni. Se scegli una data antecedente considera che la data effettiva di check-in potrebbe essere posticipata di qualche giorno',
        },
        userInfo: {
          title: 'Dicci qualcosa in più su di te!',
          age: {
            title: 'Quanti anni hai?',
            placeholder: "Inserisci l'età",
            error: 'L\'età deve essere compresa tra 18 e 99 anni',
          },
          gender: {
            title: 'Qual è il tuo genere',
            placeholder: 'Seleziona un sesso',
            male: 'Uomo',
            female: 'Donna',
            notSpecified: 'Preferisco non specificarlo',
          },
          work: {
            title: 'Cosa fai nella vita?',
            placeholder: 'Seleziona la tua professione',
            italianStudent: 'Studente italiano',
            foreignStudent: 'Studente straniero',
            selfEmployed: 'Lavoratore autonomo',
            employee: 'Lavoratore dipendente',
          },
          nationality: {
            title: 'Da dove sei?',
            placeholder: 'Seleziona la tua nazione',
          },
          message: {
            title: 'Presentati al proprietario e aggiungi eventuali richieste',
            placeholder:
              'Ti serve negoziare con il proprietario delle riparazioni, modifiche all’arredamento o la possibilità di portare un animale domestico?',
          },
        },
        paymentInfo: {
          title: 'Invia la richiesta!',
          easypay: {
            heardAboutEasypay: 'Vuoi pagare a rate con EasyPay?',
            serviceFeeAndSecurityDeposit: "Ora puoi suddividere la tua commissione di servizio e il deposito cauzionale in 24 rate mensili da soli {{price}}{{currency}}!<br /> E la parte migliore? Alla fine del contratto, ti verrà restituito il deposito cauzionale.",
          },
          titleCounteroffer: `Se accetti la controproposta avrai bloccato l'alloggio che volevi.`,
          subtitleTitleCounteroffer:
            'Ti basta inserire i dati di pagamento e cliccare su Accetta per pagare la prima mensilità di affitto che rimarrà sul tuo account Zappyrent fino al giorno del check-in.',
          adviceCost: {
            title: 'Prezzo troppo alto? Proponi il tuo prezzo.',
            subtitle: 'Puoi proporre un affitto, ma l’accettazione non è garantita. Se approvato, gli importi cambieranno.',
            subtitleOwnerIsPropertyManager: 'Su questo alloggio non puoi offrire un prezzo più basso',
            min75percentage:
              'I proprietari non accettano uno sconto cosi alto. Fai una proposta più alta o <1>torna torna alla ricerca filtrata con prezzo massimo di {{price}}€</1>',
          },
          typePayment: {
            title: 'Paga con',
            placeholder: 'Seleziona il metodo di pagamento',
            card: 'Paga con carta',
            banktransfer: 'Paga con bonifico',
            confidentText:
              'Garanzia del 100% di rimborso in caso di prenotazione non accettata o se il controllo del credito viene respinto.',
          },
          card: {
            number: 'Numero di carta',
            expire: 'Scade il',
            cvc: 'CVC',
            notSupported: "Ops, questa carta non è accettata. Riprovi con un'altra carta.",
          },
          toChangePaymentDetails: 'Per cambiare il metodo di pagamento, clicca <1>{{hereText}}</1>',
          here: 'qui',
          cardHolderName: 'Titolare della carta',
          cardHolderEmail: 'Email del titolare della carta',
          cardHolderAddress: 'Indirizzo del titolare della carta',
          cardHolderCity: 'Città del titolare della carta',
          cardHolderZip: 'CAP del titolare della carta',
          cardHolderCountry: 'Paese del titolare della carta',
          transfer: {
            alert:
              'La tua offerta arriverà al padrone di casa solo quando il pagamento sarà visibile nel sistema. Attenzione: il bonifico bancario potrebbe impiegare fino a 5 giorni per essere registrato, <strong>non perdere la tua nuova casa!</strong>',
            uploadInputHeader: 'Carica la ricevuta del tuo bonifico',
            receipt: 'Ricevuta',
            confirmDeleteReceipt: 'Sei sicuro di voler eliminare la ricevuta?',
            checkingReceipt: 'Controllo ricevuta...',
            refreshButton: 'Ricarica la pagina',
            noResponseErrorUploadTitle: 'Errore durante il caricamento',
            noResponseErrorUploadAlert:
              'Ops! Sembra che stiamo riscontrando un problema imprevisto. Ti preghiamo di aggiornare la pagina e di provare a caricare nuovamente il documento se non è già stato caricato. Se incontri ancora difficoltà, non esitare a contattarci per ulteriore assistenza. Grazie per la tua pazienza!',
          },
          termsAndCondition: {
            title:
              'Capisco che in caso di mancata conferma del pagamento, questa richiesta verrà annullata, e accetto i <1>termini e le condizioni</1> di ZappyRent.',
            error: 'È necessario confermare per poter procedere con la richiesta',
          },
          collaborateWithUs: 'Collabora con noi',
        },
      },
      changePaymentMethod: {
        title: 'Cambia metodo di pagamento per il tuo booking!',
        subtitle:
          'Qui puoi aggiornare i dati della tua carta per il tuo booking, custodiremo queste informazioni in modo sicuro. \n Non addebiteremo nssuna somma.',
        form: {
          success: 'Modifica modalità di pagamento avvenuta con successo',
          error: 'Si è verificato un errore, riprova più tardi',
        },
      },
      form: {
        next: 'Avanti',
        complete: 'Conferma',
        back: 'Torna indietro',
        amount:
          'Stai pagando <1>0€</1>. Faremo il primo addebito ({{price}}€)<2>*</2>  quando la tua proposta viene accettata dal proprietario.',
        acceptCounteroffer: 'Accetta',
        rejectCounteroffer: 'Rifiuta',
        counterofferRejectedMessage: 'Controfferta rifiutata correttamente',
      },
      banners: {
        ratting: 'Più del 93% degli inquilini soddisfatti dei nostri servizi',
        nextSteps: 'Prossimi passaggi',
        downloadOfficialDocument:
          'Dopo la conferma, <1>puoi scaricare un documento ufficiale</1> con i dettagli della tua prenotazione.',
        firstMonthRentWithPrePayment:
          "All'accettazione del padrone di casa, devi pagare il <1>primo mese di affitto</1> meno quanto hai già pagato ({{prepayment}}€) entro 24 ore.",
        firstMonthRentWithoutPrePayment:
          "All'accettazione del padrone di casa, devi pagare il <1>primo mese di affitto</1> entro 24 ore.",
        creditCheckAnalysis:
          "Successivamente, eseguiremo <1>un'analisi del controllo del credito</1> sui documenti che hai inviato.",
        zappyrentCommision: 'Approvato il controllo del credito, pagherai <1>la commissione di ZappyRent</1> entro 24 ore.',
        moneyBackGuaranteed:
          '<1>Garanzia del 100% di rimborso</1> se la tua prenotazione non viene accettata o il controllo del credito non viene approvato.',
      },
      fundingInstruction: {
        account: 'Intestatario del conto',
        nation: 'Nazione',
      },
      easyPayPlan: {
        title: 'Piano EasyPay',
        moveIntoHomeWithoutPayingAnything: 'Vuoi entrare in casa senza pagare nulla o solo una piccola somma in anticipo?',
        subtitle: '<1>Con soli 18,40€/mese (per 24 mesi) attivi il Premium Plan e accedi a vantaggi esclusivi:</1>',
        advertise: {
          title: 'EasyPay',
          heading: 'Entra nella tua nuova casa senza pagare nulla o solo una piccola somma!',
          disclaimer: 'Paga <1>commissioni e deposito cauzionale*</1> in 24 comode rate mensili',
          footerPara: 'Prenota con EasyPay e goditi tutti gli altri vantaggi dell’abbonamento!!',
          footerNote: '*(fino a {{easy_pay_loan_amount}}{{currency}}) '
        },
        benefit: {
          title: 'Prenota con EasyPay e scopri tutti gli altri vantaggi!',
          benefit_1: '<1>Maggiore flessibilità economica:</1> Puoi pagare la commissione e il deposito cauzionale in 24 rate.',
          benefit_2: '<1>Assistenza prioritaria:</1> Hai un canale diretto e veloce per ricevere supporto quando ne hai più bisogno.',
          benefit_3: '<1>Ispezione anticipata check-out:</1> Con il nostro aiuto, avrai la possibilità di risolvere eventuali problematiche causate durante il tuo soggiorno, evitando così addebiti dal deposito cauzionale.',
          benefit_4: '<1>Flessibilità nel pagamento dell\'affitto:</1> Invece di giorno 1, potrai pagare l\'affitto fino al 8 del mese senza penali.',
          benefit_5: '<1>Restituzione del deposito:</1> Alla fine del contratto riceverai indietro il deposito cauzionale, a condizione che vengano rispettate le clausole del contratto e in base alle condizioni dell\'appartamento.',
          bookWithEasyPay: 'Prenota con EasyPay',
          discoverOtherAdvantages: 'Scopri gli altri vantaggi',
        },
        bookWithEasyPayPlan: {
          title: 'Vorrei prenotare con EasyPay',
          subtitle: 'Da pagare <1>prima di entrare in casa:</1>',
          installment: 'Pagamento <1>mensile</1> per <1>24 mesi:</1>',
          disclaimer: '*Il costo Easy Pay ({{premium_fee}}{{currency}}) è già incluso'
        },
        bookWithoutEasyPayPlan: {
          title: 'Vorrei prenotare senza EasyPay',
          subtitle: 'Da pagare prima di entrare in casa:',
          disclaimer: 'Commissione {{commission}}{{currency}} + Deposito {{deposit}}{{currency}} = {{upfront_total}}{{currency}}'
        },
        tooltip: {
          title: 'Da pagare prima di entrare in casa:',
          tip_1: '1. Commissione + deposito = <1>{{currency}}{{comission_plus_deposit_amount}}</1>',
          tip_2: '2. Importo <1>coperto da Easypay</1> = <2>{{currency}}{{easy_pay_amount}}</2>',
          tip_3: '3. Totale richiesto con EasyPay (costi easypay inclusi {{premium_fee_amount}}{{currency}}) = <1>{{currency}}{{easypay_total_amount}}</1>',
          disclaimer: 'Importo da pagare prima di entrare in casa (1 - 2)  = {{currency}}{{easypay_remaining_amount}}'
        }
      }
    },
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    defaultNS: 'translations',
    ns: ['translations', 'errors'],
    fallbackLng: 'en',
    supportedLngs: ['en', 'it'],

    keySeparator: '.', // we do not use keys in form messages.welcome
    lng: split(navigator.language, '-')[0],
    whitelist: ['it', 'en'],
    nsSeparator: ':',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    debug: process.env.NODE_ENV === 'local',
  })

export default i18n
